<template>
    <div class="components-container">
        <el-dialog :visible.sync="isShowModel" width="65%" center>
            <div class="row form-horizontal">
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Reward Name </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input v-model="filterParams.name" name="search"></el-input>
                        </div>
                    </div>
                    <div class="col-sm-2 textRight">
                        <div class>
                            <el-button type="primary" @click="getSchoolList">{{
                                $t("message.Search")
                            }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row table-responsive" style="padding-bottom: 60px">
                <el-table :header-row-style="{
                    'background-color': '#EBEBEB',
                    color: '#676a6c',
                }" :highlight-current-row='!isMultiple' :data="rewardList" style="width: 100%" ref="multipleTable"
                    :fit="true" class="rowss" row-key="id" @current-change="handleSelectionChange"
                    @selection-change="handleMultipleSelectionChange">
                    <el-table-column v-if="isMultiple" type="selection" width="55"></el-table-column>
                    <el-table-column label="Reward Name" :show-overflow-tooltip="true" min-width="200">
                        <template slot-scope="scope">
                            <div>
                                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.expired">
                                    Expired
                                </el-tag>
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="statusName" label="Status" min-width="70"></el-table-column>
                    <el-table-column prop="updatedAt" label="Last Update Time" width="170">
                    </el-table-column>
                    <el-table-column prop="updatedBy" label="Last Update By" width="170">
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="el-table_footertoolbar">
                    <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50, 100, 200]" :page-size="filterParams.pageSize" :total="total"
                        style="float: right">
                    </el-pagination>
                </el-col>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeModel">Cancel</el-button>
                <el-button type="primary" :disabled='isMultiple ? !selectResList.length : !selectResCode'
                    @click="handleAdd">Add</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import config from "../../config";
export default {
    name: "schoolSelectModel",
    components: {},
    mixins: [config.globalMixin],
    data() {
        return {
            isShowModel: false,
            filterParams: {
                name: "",
                pageSize: 5,
                pageIndex: 1,
                sortType: "ASC",
                sortField: "sortOrder",
            },
            rewardList: [],
            total: 0,
            selectResCode: null,
            selectResList: [],
        };
    },
    props: {
        isShowAddModel: {
            type: Boolean,
            default: false,
        },
        districtCode: {
            type: String,
            default: '',
        },
        isMultiple: {
            tyoe: Boolean,
            default: false
        }
    },
    watch: {
        isShowModel: {
            handler: function (e) {
                if (!e) this.$emit("close", e);
            },
        },
        isShowAddModel: {
            handler: function (e) {
                if (e) {
                    this.isShowModel = e;
                }
            },
            immediate: true,
        },
    },
    computed: {
        statusNameMap(){
            return {
                0:this.$i18n.t("message.Inactive"),
                1:this.$i18n.t("message.Active"),
            }
        }
    },
    methods: {
        closeModel() {
            this.selectResList = []
            this.selectResCode = null
            this.$forceUpdate()
            this.isShowModel = false;
        },
        handleAdd() {
            this.$emit("add", this.isMultiple ? this.selectResList : this.selectResCode)
            this.closeModel();
        },
        async getSchoolList() {
            let obj = this.getAuthObj();
            obj.apiUrl = this.apiConfig.giftList;
            const params = {
                ...obj,
                ...this.filterParams,
            };
            let data = await this.$store.dispatch("apiEvent", params);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.total = data.data.result.total;
            this.rewardList = data.data.result.gifts.map(i=>{
                return {
                    ...i,
                    statusName:this.statusNameMap[i.status]
                }
            });
        },
        handleCurrentChange(val) {
            this.filterParams.pageIndex = val;
            this.getSchoolList();
        },
        handleCurrentChange(val) {
            this.filterParams.pageIndex = val;
            this.getSchoolList();
        },
        handleSelectionChange(e) {
            if (!this.isMultiple) this.selectResCode = e;
        },
        handleMultipleSelectionChange(e) {
            if (this.isMultiple) this.selectResList = e
        }
    },
    mounted() {
        this.getSchoolList();
    },
    created() {
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table__body tr.current-row>td.el-table__cell {
    background-color: #1ab394 !important;
    color: #ffffff
}

.components-container {}
</style>
  